import { render } from "./formApoReport.vue?vue&type=template&id=22fac9d2"
import script from "./formApoReport.vue?vue&type=script&lang=js"
export * from "./formApoReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__